<template>
  <article class="legal-content">
    <p>{{ content.intro }}</p>
    <section v-for="[title, body] in content.sections" :key="title">
      <h2>{{ title }}</h2>
      <p>{{ body }}</p>
    </section>
  </article>
</template>

<script setup>
/* global defineProps */
import { computed } from 'vue'

const props = defineProps({ document: { type: String, required: true } })
// Existing Android test-service documents, kept verbatim.
const documents = {
  agreement: {
    intro: '欢迎使用云手机测试服务（以下简称“本服务”）。本协议用于说明测试阶段你与本服务之间的基本权利和义务。勾选同意或使用本服务，即表示你已阅读并同意本协议。',
    sections: [
      ['一、测试服务说明', '本服务目前处于测试阶段，功能、容量、可用时间及服务规则可能调整、暂停或终止。测试服务不构成对持续可用、无故障或特定功能效果的承诺。请勿将其用于生产业务、紧急场景或保存唯一副本的数据。'],
      ['二、账号与使用', '你应使用本人可控制的账号登录，并妥善保管账号和密码。因账号、密码保管不当造成的风险由你自行承担。发现账号异常时，请立即停止使用并通过测试邀请渠道联系我们。'],
      ['三、使用规范', '你不得利用本服务实施违法违规活动，不得传播违法、有害或侵权内容，不得干扰平台、云手机或网络的正常运行，不得尝试未获授权的访问、扫描、攻击、挖矿、恶意程序传播或资源占用。'],
      ['四、云手机与文件', '云手机中的应用、文件、账号信息及操作结果由你自行负责。测试设备可能因到期、回收、维护、故障或规则调整被重置，导致设备内数据、上传文件或配置丢失。请自行备份重要数据。'],
      ['五、服务调整与反馈', '为改进测试体验，本服务可能收集并分析故障日志、功能使用情况和你主动提交的反馈。我们可根据安全、容量或维护需要调整服务；发生影响使用的情况时，将尽力通过应用内或测试邀请渠道告知。'],
      ['六、责任限制', '在法律允许的范围内，测试阶段因网络、第三方基础设施、设备维护、不可抗力或服务调整导致的访问中断、数据丢失、文件损坏或其他损失，本服务将依法承担相应责任，但不对可预见之外的间接损失作出承诺。'],
      ['七、协议更新与联系', '本协议可能随服务发展更新。更新后的内容将在应用内公布。你可通过邀请你参与测试的渠道反馈问题、提出意见或行使本协议相关权利。']
    ]
  },
  privacy: {
    intro: '本隐私政策说明云手机测试服务如何处理你在使用过程中提供或产生的信息。测试阶段请勿上传身份证件、银行卡、医疗信息、生物识别信息、商业秘密等敏感或重要资料。',
    sections: [
      ['一、我们处理的信息', '为提供账号登录和云手机服务，我们可能处理：你注册时填写的账号；登录时提交的密码；账号状态和登录结果；你绑定或使用的云手机设备标识、操作指令和必要的运行日志；以及你主动上传至云手机的文件。服务端仅保存密码哈希值，不保存可直接用于登录的明文密码。'],
      ['二、处理目的', '我们仅在提供登录认证、云手机控制、文件传输与安装、故障排查、安全防护、容量管理和测试改进所必需的范围内处理上述信息。未经你的同意，不会将你的个人信息用于与本服务无关的营销用途。'],
      ['三、存储与删除', '信息将在实现服务目的所必需的期限内保存，并可能因安全、审计或法律要求适当延长。云手机内的文件和数据可能因设备重置、回收、到期或测试维护而清除；上传过程中的临时文件会按照服务规则清理。'],
      ['四、共享与委托处理', '为提供云手机能力，你的设备标识、必要操作指令及上传文件可能被传输至被分配的云手机设备、存储服务或基础设施提供方进行处理。我们不会出售你的个人信息，也不会向无关第三方提供你的个人信息。'],
      ['五、安全措施', '我们将采取合理的访问控制、权限管理、日志审计和密码哈希存储等措施保护信息安全。测试环境的安全能力不等同于正式商用环境，因此请避免处理敏感个人信息和重要资料。'],
      ['六、你的权利与联系', '你可以通过测试邀请渠道提出查阅、更正、删除账号相关信息或撤回同意的请求。我们会在核验身份并符合适用法律和服务规则的前提下处理。'],
      ['七、政策更新', '当处理目的、信息类型或服务能力发生实质变化时，本政策可能更新。更新后的内容将在应用内展示；继续使用服务前，请阅读最新版本。']
    ]
  }
}
const content = computed(() => documents[props.document] || documents.agreement)
</script>

<style scoped>
.legal-content { color: #52625f; font-size: 14px; line-height: 1.85; overflow-wrap: anywhere; }
.legal-content h2 { color: #24262b; font-size: 16px; margin: 24px 0 8px; }
.legal-content p { margin: 0 0 12px; }
</style>
